import React, { useEffect, useState, useRef } from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Collapse,
  Typography,
  Grid,
  tableCellClasses,
  InputAdornment,
  Dialog,
  Checkbox,
  Button,
  DialogActions,
  DialogTitle,
  DialogContent,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { PrimaryButton } from "components/Buttons";
import InputField from "components/Input";
import styled from "@emotion/styled";
import Colors from "assets/Style/Colors";
import { FontFamily, SearchIcon } from "assets";
import { useForm } from "react-hook-form";
import Pagination from "components/Pagination";
import VendorServices from "services/Vendor";
import { ErrorToaster, SuccessToaster } from "components/Toaster";
import { CommaSeparator, formatPermissionData } from "utils";
import DropdownMenu from "components/DropDown";
import { addPermission } from "redux/slices/navigationDataSlice";
import { useDispatch } from "react-redux";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { PDFExport } from "@progress/kendo-react-pdf";
import { FormControl } from "@mui/material";
import DatePicker from "components/DatePicker";
import moment from "moment";

const Row = styled(TableRow)(({ theme }) => ({
  border: 0,
}));

const Cell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    fontSize: 14,
    fontFamily: FontFamily.NunitoRegular,
    border: 0,
    whiteSpace: "nowrap",
    background: Colors.primary,
    color: Colors.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    fontFamily: FontFamily.NunitoRegular,
    textAlign: "center",
    textWrap: "nowrap",
    padding: "5px !important",
    padding: "5px !important",

    ".MuiBox-root": {
      display: "flex",
      gap: "6px",
      alignItems: "center",
      justifyContent: "center",
      ".MuiBox-root": {
        cursor: "pointer",
      },
    },
    svg: {
      width: "auto",
      height: "24px",
    },
    ".MuiTypography-root": {
      textTransform: "capitalize",
      fontFamily: FontFamily.NunitoRegular,
      textWrap: "nowrap",
    },
    ".MuiButtonBase-root": {
      padding: "8px",
      width: "28px",
      height: "28px",
    },
  },
}));
const LoadingPlanList = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // *For Pagination
  const [totalCount, setTotalCount] = useState(0);
  const [pageLimit, setPageLimit] = useState(20);
  const [currentPage, setCurrentPage] = useState(1);
  const [open, setOpen] = useState({});
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  // const [loadingPort, setLoadingPort] = useState("");
  // const [sourceLocation, setSourceLocation] = useState("");
  // const [destination, setDestination] = useState("");
  // const [towingVendor, setTowingVendor] = useState("");
  // const [shippingVendor, setShippingVendor] = useState("");
  const [vendorPlans, setVendorPlans] = useState([]);

  console.log(vendorPlans, 'vendorPlans')
  const [planVendor, setPlanVendor] = useState([]);
  const [loader, setLoader] = useState(false);
  const [filters, setFilters] = useState({});
  const [activeMenu, setActiveMenu] = useState(null);
  const [planId, setPlanId] = useState(null);
  const [permissions, setPermissions] = useState();
  const contentRef = useRef(null);
  const [isDialogOpen, setDialogOpen] = useState(false);
  const [tableId, setTableId] = useState();
  const [dispatchFilter, setDispatchFilter] = useState("all");
  const [downloadData, setDownloadData] = useState(null);
  // const [groupedRawPlans, setGroupedRawPlans] = useState({});
  const {
    register,
    handleSubmit,
    formState: { errors },
    getValues,
  } = useForm();

  const handleOpenDialog = (item) => {
    setTableId(item);
    setDialogOpen(true);
  };

  // Example options for the SelectField
  const loadingPortOptions = [
    { name: "Port A", id: "portA" },
    { name: "Port B", id: "portB" },
  ];
  const sourceLocationOptions = [
    { name: "Source 1", id: "source1" },
    { name: "Source 2", id: "source2" },
  ];
  const destinationOptions = [
    { name: "Destination 1", id: "destination1" },
    { name: "Destination 2", id: "destination2" },
  ];
  const towingVendorOptions = [
    { name: "Vendor 1", id: "vendor1" },
    { name: "Vendor 2", id: "vendor2" },
  ];
  const shippingVendorOptions = [
    { name: "Vendor A", id: "vendorA" },
    { name: "Vendor B", id: "vendorB" },
  ];
  const toggleRow = (referenceNo) => {
    setOpen((prev) => ({
      //   ...prev,
      [referenceNo]: !prev[referenceNo],
    }));
  };

  const getVendorPlan = async (page, limit, filter) => {
    setLoader(true);
    try {
      const Page = page || currentPage;
      const Limit = limit || pageLimit;
      const Filter = {
        ...filters,
        ...filter,
        ...(dispatchFilter && { dispatch: dispatchFilter }),
      };

      setCurrentPage(Page);
      setPageLimit(Limit);
      setFilters(Filter);

      const params = { page: Page, limit: Limit, ...Filter };
      const { data } = await VendorServices.getCreatePlan(params);

      setPlanVendor(data?.plans?.rows);
      // const sortedPlans = data?.plans?.rows
      //   ?.filter((plan) => plan?.vehicles?.plans?.created_at)
      //   ?.sort(
      //     (a, b) =>
      //       new Date(b?.vehicles?.plans?.created_at) -
      //       new Date(a?.vehicles?.plans?.created_at)
      //   );
      const sortedPlans = [...data?.plans?.rows].sort((a, b) => {
        const dateA = new Date(a?.vehicles?.plans?.created_at || 0);
        const dateB = new Date(b?.vehicles?.plans?.created_at || 0);
        return dateB - dateA;
      });

      setPermissions(formatPermissionData(data?.permissions));
      data?.permissions?.forEach((e) => {
        if (e?.route && e?.identifier && e?.permitted) {
          dispatch(addPermission(e?.route));
        }
      });

      const rows = sortedPlans.map((plan) => {
        const vehicle = plan.vehicles || {};
        const invoice = plan.invoice || {};
        const paid = Math.ceil(Number(invoice?.paid || 0));
        const amount = Math.ceil(Number(invoice?.amount || 0));
        return {
          id: plan?.id,
          vendor_costing_data: plan?.vehicle,
          auctioner: plan?.buyer?.auction?.name,
          purchase_date: plan?.purchase_date,
          booking_ref_no: vehicle?.plans?.booking_ref_no,
          container_no: plan?.vehicle?.shipping?.container?.name,
          suggested_ship_vendor: plan?.ship_vendor?.name,
          suggested_ship_vendor_id: plan?.ship_vendor?.id,
          suggested_towing_vendor: plan?.tower?.name,
          suggested_towing_vendor_id: plan?.tower?.id,
          towing_cost: vehicle?.plans?.towing_cost,
          shipping_cost: vehicle?.plans?.shipping_cost,
          estimated_price: vehicle?.plans?.estimated_price,
          total_cost: parseFloat(vehicle?.plans?.estimated_price || 0),
          created_at: vehicle?.plans?.created_at,
          warehouse: plan?.warehouse,
          pickup_date: plan?.pickup_date,
          delivery_date: plan?.delivery_date,
          vehicle,
          loading_port: plan?.vehicle?.shipping?.loading_port,
          customer_name: plan?.customer?.name,
          customer_id: plan?.customer?.id,
          master_id: plan?.buyer?.master_id,
          notes: plan?.notes,
          gp_pin: plan?.gp_pin,
          off_site: plan?.off_site,
          destination: plan?.destination
            ? plan?.destination
            : { id: 1, name: "Jebel Ali, Dubai, UAE" },
          model: plan?.veh_model?.name,
          title: plan?.title_status,
          vin: plan?.vin,
          lot_number: plan?.lot_number,
          dispatch_status: vehicle?.dispatch_status,
          buyer_name: plan?.buyer?.name,
          invoice_status:
            paid === amount && paid > 0
              ? "Paid"
              : paid === 0 || amount === 0
              ? "UnPaid"
              : "Partial Paid",
        };
      });

      setVendorPlans(rows);
      setDownloadData(rows);
      setTotalCount(data?.plans?.count);
    } catch (error) {
      ErrorToaster(error);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    getVendorPlan(currentPage, pageLimit);
  }, [currentPage, pageLimit, dispatchFilter]);

  const applyFilter = async (value) => {
    try {
      let data = {
        search: getValues("search"),
      };
      getVendorPlan(1, "", data);
    } catch (error) {
      ErrorToaster(error);
    }
  };
  const handleMenuToggle = (menuId, isOpen) => {
    setActiveMenu(isOpen ? menuId : null); // Toggle the active menu
  };

  const deletePlan = async () => {
    try {
      let params = {
        plan_id: planId?.vehicle?.plans?.id,
      };

      const { data, message } = await VendorServices.deletePlan(params);
      getVendorPlan();
      handleClose();
      SuccessToaster(message);
    } catch (error) {
      ErrorToaster(error);
    }
  };
  const handleClose = () => {
    setOpenDeleteDialog(false);
  };

  const tableHead = [
    "Reference No.",
    "Container No.",
    "Towing Cost",
    "Shipping Cost",
    "Total Cost",
    "Action",
    "Customer",
    "Auctioner",
    "Purchase Date",
    "Master ID",
    "Buyer ID",
    "VIN",
    "LOT",
    "Model",
    "Title",
    "Location",
    "Load Port",
    "GP Pin",
    "Off Site",
    "Destination",
    "Status",
    "Vehicle Payment Status",
    "Notes",
  ];

  const downloadExcel = async (selectedRefNo) => {
    const headers = tableHead.filter(
      (item) => item !== "Actions" || item !== "Action"
    );
    const allRows = [];
    const selectedPlan = downloadData?.find(
      (plan) => plan.booking_ref_no === selectedRefNo
    );
    if (selectedPlan) {
      allRows.push([
        selectedPlan?.booking_ref_no,
        selectedPlan?.container_no,
        selectedPlan?.towing_cost,
        selectedPlan?.shipping_cost,
        selectedPlan?.total_cost,
        selectedPlan?.action || "-",
        selectedPlan?.customer_name,
        selectedPlan?.auctioner,
        selectedPlan?.purchase_date.slice(0, 10),
        selectedPlan?.master_id?.master_id,
        selectedPlan?.buyer_name,
        selectedPlan?.vin,
        selectedPlan?.lot_number,
        selectedPlan?.model,
        selectedPlan?.title,
        selectedPlan?.vehicle?.source,
        selectedPlan?.loading_port?.name,
        selectedPlan?.gp_pin,
        selectedPlan?.off_site,
        selectedPlan?.destination?.name,
        selectedPlan?.dispatch_status,
        selectedPlan?.invoice_status,
        selectedPlan?.notes,
      ]);
    }

    if (allRows.length === 0) {
      alert("No data available for the selected reference number.");
      return;
    }

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Sheet1");
    worksheet.addRow(headers);
    allRows.forEach((r) => worksheet.addRow(r));

    const buffer = await workbook.xlsx.writeBuffer();
    saveAs(new Blob([buffer]), "data.xlsx");
  };

  const handleFilterChange = (event) => {
    setDispatchFilter(event.target.value);
  };

  const [openDateDialog, setOpenDateDialog] = useState(false);
  const [pickupDate, setPickupDate] = useState(null);
  const [dispatchDate, setDispatchDate] = useState(null);
  const [deliveryDates, setDeliveryDate] = useState(null);

  const [selectedRows, setSelectedRows] = useState([]);
  const handleRowSelection = (group) => {
    if (!group?.vehicle?.id) return;

    const vehicleId = group.vehicle.id;

    const isAlreadySelected = selectedRows.some(
      (row) => row.vehicle.id === vehicleId
    );

    let updatedSelection;
    if (isAlreadySelected) {
      updatedSelection = selectedRows.filter(
        (row) => row.vehicle.id !== vehicleId
      );
    } else {
      updatedSelection = [...selectedRows, group];
    }

    setSelectedRows(updatedSelection);

    if (!isAlreadySelected) {
      setDispatchDate(
        group?.vehicle?.dispatch_date
          ? new Date(group.vehicle.dispatch_date)
          : ""
      );
      setPickupDate(group?.pickup_date ? new Date(group.pickup_date) : "");
      setDeliveryDate(
        group?.delivery_date ? new Date(group.delivery_date) : ""
      );
    }
  };

  return (
    <Box sx={{ padding: "20px" }}>
      <Dialog
        open={openDeleteDialog}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <Typography
          sx={{
            p: 3,
            px: 5,
            fontSize: 17,
            fontFamily: FontFamily.openSans,
            fontWeight: "bold",
          }}
          id="alert-dialog-title"
        >
          {"Are You Sure You Want To Delete Plan?"}
        </Typography>

        <Grid item xs={12} sm={12} sx={{ mb: 2, textAlign: "center" }}>
          <PrimaryButton
            title="No"
            type="submit"
            buttonStyle={{ minWidth: "120px" }}
            onClick={() => {
              handleClose();
            }}
          />
          <Box component={"span"} sx={{ mx: 1 }} />
          <PrimaryButton
            title="Yes"
            type="button"
            buttonStyle={{
              minWidth: "120px",
              bgcolor: Colors.danger,
              "&:hover": { bgcolor: Colors.danger },
            }}
            bgcolor={Colors?.danger}
            onClick={() => {
              deletePlan();
            }}
          />
        </Grid>
      </Dialog>
      <Box
        sx={{
          display: "flex",
          gap: "11px",
          alignItems: "center",
          mb: 1,
          mt: 6,
        }}
      >
        <Typography
          variant="h5"
          sx={{
            color: Colors.charcoalGrey,
            fontFamily: FontFamily.NunitoRegular,
          }}
        >
          VAD Plan List
        </Typography>
      </Box>
      {/* Top Section */}
      <Box
        sx={{
          boxShadow: "0px 4px 4px 2px #00000040",
          p: 3,
          borderRadius: "12px",
        }}
      >
        <Grid
          container
          spacing={2}
          sx={{
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Grid item xs={12} sm={3.5}>
            <InputField
              size={"small"}
              inputStyle={{ backgroundColor: "#f5f5f5" }}
              label={"Search"}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
              placeholder={"Search"}
              register={register("search", {
                onChange: (e) => applyFilter(e?.target?.value),
              })}
            />
          </Grid>
          <Grid item sm={3.5}></Grid>
          <Grid
            item
            xs={12}
            sm={5}
            sx={{ display: "flex", justifyContent: "end" }}
          >
            <FormControl size="small" sx={{ minWidth: 200 }}>
              <InputLabel id="dispatch-filter-label">
                Dispatch Status
              </InputLabel>
              <Select
                labelId="dispatch-filter-label"
                id="dispatch-filter"
                value={dispatchFilter}
                label="Dispatch Status"
                onChange={handleFilterChange}
              >
                <MenuItem value="all">All</MenuItem>
                <MenuItem value="true">Dispatched</MenuItem>
                <MenuItem value="false">Not Dispatched</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          {selectedRows?.length > 0 && (
            <Grid item xs={12} textAlign="right">
              <PrimaryButton
                title="Update Date"
                onClick={() => setOpenDateDialog(true)}
              />
            </Grid>
          )}
          {/* <Grid item xs={12} sm={3}>
            <SelectField
              label={"Loading Port"}
              options={loadingPortOptions}
              selected={loadingPort}
              onSelect={(value) => setLoadingPort(value)}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <SelectField
              label={"Source Location"}
              options={sourceLocationOptions}
              selected={sourceLocation}
              onSelect={(value) => setSourceLocation(value)}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <SelectField
              label={"Destination"}
              options={destinationOptions}
              selected={destination}
              onSelect={(value) => setDestination(value)}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <SelectField
              label={"Towing Vendor"}
              options={towingVendorOptions}
              selected={towingVendor}
              onSelect={(value) => setTowingVendor(value)}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <SelectField
              label={"Shipping Vendor"}
              options={shippingVendorOptions}
              selected={shippingVendor}
              onSelect={(value) => setShippingVendor(value)}
            />
          </Grid> */}

          <Grid item xs={2} sm={2} mt={2} textAlign={"right"} gap={1}>
            {/* <PrimaryButton onClick={() => { applyFilter() }} title={"Search"} /> */}
          </Grid>
        </Grid>

        <Dialog
          open={openDateDialog}
          onClose={() => setOpenDateDialog(false)}
          fullWidth
        >
          <DialogTitle>Update Dates</DialogTitle>
          <DialogContent>
            <Grid container spacing={2} mt={1}>
              <Grid item xs={12}>
                <DatePicker
                  label="Dispatch Date"
                  value={dispatchDate || ""}
                  onChange={(date) => setDispatchDate(date)}
                  slotProps={{ textField: { fullWidth: true, size: "small" } }}
                />
              </Grid>
              <Grid item xs={12}>
                <DatePicker
                  // disabled={!selectedRows?.vehicle?.dispatch_date}
                  label="Pickup Date"
                  value={pickupDate || ""}
                  onChange={(date) => setPickupDate(date)}
                  slotProps={{ textField: { fullWidth: true, size: "small" } }}
                />
              </Grid>

              <Grid item xs={12}>
                <DatePicker
                  // disabled={
                  //   !selectedRows?.vehicle?.dispatch_date ||
                  //   !selectedRows?.vehicle?.pickup_date
                  // }
                  label="Delivery Date"
                  value={deliveryDates || ""}
                  onChange={(date) => setDeliveryDate(date)}
                  slotProps={{ textField: { fullWidth: true, size: "small" } }}
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenDateDialog(false)}>Cancel</Button>
            <Button
              variant="contained"
              onClick={async () => {
                const payload = {
                  vehicles: selectedRows.map((row) => ({
                    booking_id: row?.vehicle?.booking_id,
                    vin: row?.vin,
                  })),
                  dispatch_date: dispatchDate
                    ? moment(dispatchDate).format("DD-MM-YYYY")
                    : null,
                  pickup_date: pickupDate
                    ? moment(pickupDate).format("DD-MM-YYYY")
                    : null,
                  delivery_date: deliveryDates
                    ? moment(deliveryDates).format("DD-MM-YYYY")
                    : null,
                };

                const res = await VendorServices.updateVendorDate(payload);
                getVendorPlan();
                SuccessToaster(res.message);
                setOpenDateDialog(false);
              }}
            >
              Save
            </Button>
          </DialogActions>
        </Dialog>

        {/* //   <Grid item xs={12} sm={3}>
      //   <SelectField
      //     label={"Loading Port"}
      //     options={loadingPortOptions}
      //     selected={loadingPort}
      //     onSelect={(value) => setLoadingPort(value)}
      //   />
      // </Grid>
      // <Grid item xs={12} sm={3}>
      //   <SelectField
      //     label={"Source Location"}
      //     options={sourceLocationOptions}
      //     selected={sourceLocation}
      //     onSelect={(value) => setSourceLocation(value)}
      //   />
      // </Grid>
      // <Grid item xs={12} sm={3}>
      //   <SelectField
      //     label={"Destination"}
      //     options={destinationOptions}
      //     selected={destination}
      //     onSelect={(value) => setDestination(value)}
      //   />
      // </Grid>
      // <Grid item xs={12} sm={3}>
      //   <SelectField
      //     label={"Towing Vendor"}
      //     options={towingVendorOptions}
      //     selected={towingVendor}
      //     onSelect={(value) => setTowingVendor(value)}
      //   />
      // </Grid>
      // <Grid item xs={12} sm={3}>
      //   <SelectField
      //     label={"Shipping Vendor"}
      //     options={shippingVendorOptions}
      //     selected={shippingVendor}
      //     onSelect={(value) => setShippingVendor(value)}
      //   />
      // </Grid>
      //   <Grid item xs={12} sm={6} mt={2} textAlign={"right"}  gap={3}>
            
      //       <PrimaryButton  title={"Search"} />
          
      //   </Grid>
        
      //   </Grid> */}
      </Box>
      <Grid item md={11}>
        {/* {vendorPlans?.length > 0 && (
                    <Box
                      sx={{
                        textAlign: "right",
                        p: 4,
                        display: "flex",
                        gap: 2,
                        justifyContent: "flex-end",
                      }}
                    >
                      <PrimaryButton
                        title="Download PDF"
                        type="button"
                        style={{ backgroundColor: Colors.bluishCyan }}
                        onClick={() => handleExportWithComponent(contentRef)}
                      />
                      <PrimaryButton
                        title={"Download Excel"}
                        onClick={() => downloadExcel()}
                      />
                    </Box>
                  )} */}
      </Grid>

      <PDFExport
        ref={contentRef}
        landscape={true}
        paperSize="A4"
        margin={5}
        fileName="VAD Plans"
      >
        {/* Table Section */}
        <TableContainer style={{ marginTop: 25 }} component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <Cell />
                {/* <Cell /> */}
                <Cell style={{ textAlign: "center" }}>Reference No.</Cell>
                {/* <Cell style={{ textAlign: "center" }}>Container No.</Cell> */}
                <Cell style={{ textAlign: "center" }}>Customer</Cell>
                <Cell style={{ textAlign: "center" }}>Auctioner</Cell>
                <Cell style={{ textAlign: "center" }}>Purchase Date</Cell>
                <Cell style={{ textAlign: "center" }}>Master ID</Cell>
                <Cell style={{ textAlign: "center" }}>Buyer ID</Cell>
                <Cell style={{ textAlign: "center" }}>VIN</Cell>
                <Cell style={{ textAlign: "center" }}>LOT</Cell>

                <Cell style={{ textAlign: "center" }}>Model</Cell>
                <Cell style={{ textAlign: "center" }}>Title</Cell>
                <Cell style={{ textAlign: "center" }}>Location</Cell>
                <Cell style={{ textAlign: "center" }}>Load Port</Cell>
                <Cell style={{ textAlign: "center" }}>GP Pin</Cell>
                <Cell style={{ textAlign: "center" }}>Off Site</Cell>
                <Cell style={{ textAlign: "center" }}>Destination</Cell>

                <Cell style={{ textAlign: "center" }}>Towing Vendor</Cell>

                <Cell style={{ textAlign: "center" }}>Shipping Vendor</Cell>
                <Cell style={{ textAlign: "center" }}>Status</Cell>
                <Cell style={{ textAlign: "center" }}>Veh.Status</Cell>
                <Cell style={{ textAlign: "center" }}>Towing Cost</Cell>
                <Cell style={{ textAlign: "center" }}>Shipping Cost</Cell>
                <Cell style={{ textAlign: "center" }}>Total Cost</Cell>
                <Cell style={{ textAlign: "center" }}>Notes</Cell>
                <Cell style={{ textAlign: "center" }}>Action</Cell>
              </TableRow>
            </TableHead>
            <TableBody>
              {vendorPlans?.map((group, index) => {
                return (
                  <React.Fragment key={index}>
                    {/* Parent Row - Summary of the Plan */}
                    <TableRow
                      key={group.vehicle.id}
                      sx={{ bgcolor: index % 2 !== 0 && "#EFF8E7" }}
                    >
                      <TableCell>
                        <Checkbox
                          disabled={!group?.vehicle?.id}
                          checked={selectedRows.some(
                            (row) => row.vehicle?.id === group?.vehicle?.id
                          )}
                          onChange={() => handleRowSelection(group)}
                        />
                      </TableCell>
                      {/* <TableCell>
                        <IconButton
                          size="small"
                          onClick={() => toggleRow(index)}
                        >
                          {open[index] ? (
                            <KeyboardArrowUp />
                          ) : (
                            <KeyboardArrowDown />
                          )}
                        </IconButton>
                      </TableCell> */}
                      <TableCell style={{ textAlign: "center" }}>
                        {group.booking_ref_no || "-"}
                      </TableCell>
                      {/* <TableCell style={{ textAlign: "center" }}>
                        {group?.vehicle?.plan?.container_no || "-"}
                      </TableCell> */}
                      {/* <TableCell style={{ textAlign: "center" }}>{group.suggested_ship_vendor ?? "-"}</TableCell> */}
                      {/* <TableCell style={{ textAlign: "center" }}>
                        {group.container_no || "-"}
                      </TableCell> */}
                      <TableCell style={{ textAlign: "center" }}>
                        {group.customer_name || "-"}
                      </TableCell>
                      <TableCell style={{ textAlign: "center" }}>
                        {group?.auctioner || "-"}
                      </TableCell>
                      <TableCell style={{ textAlign: "center" }}>
                        {group?.purchase_date.slice(0, 10) || "-"}
                      </TableCell>
                      <TableCell style={{ textAlign: "center" }}>
                        {group?.master_id || "-"}
                      </TableCell>
                      <TableCell style={{ textAlign: "center" }}>
                        {group.buyer_name || "-"}
                      </TableCell>{" "}
                      <TableCell style={{ textAlign: "center" }}>
                        {group?.vin || "-"}
                      </TableCell>
                      <TableCell style={{ textAlign: "center" }}>
                        {group?.lot_number || "-"}
                      </TableCell>{" "}
                      <TableCell style={{ textAlign: "center" }}>
                        {group?.model || "-"}
                      </TableCell>{" "}
                      <TableCell style={{ textAlign: "center" }}>
                        {group?.title || "-"}
                      </TableCell>{" "}
                      <TableCell style={{ textAlign: "center" }}>
                        {group?.vehicle?.source || "-"}
                      </TableCell>
                      <TableCell style={{ textAlign: "center" }}>
                        {group?.loading_port?.name || "-"}
                      </TableCell>{" "}
                      <TableCell style={{ textAlign: "center" }}>
                        {group?.vehicle?.gp_pin || "-"}
                      </TableCell>{" "}
                      <TableCell style={{ textAlign: "center" }}>
                        {group?.vehicle?.off_site || "-"}
                      </TableCell>{" "}
                      <TableCell style={{ textAlign: "center" }}>
                        {group?.destination?.name || "-"}
                      </TableCell>
                      {/* <TableCell style={{ textAlign: "center" }}>
                        {group.suggested_towing_vendor || "-"}
                      </TableCell> */}
                      {/* <TableCell style={{ textAlign: "center" }}>
                        $
                        {CommaSeparator(parseFloat(group.towing_cost).toFixed(2))}
                      </TableCell> */}
                      <TableCell style={{ textAlign: "center" }}>
                        {group.suggested_towing_vendor || "-"}
                      </TableCell>
                      <TableCell style={{ textAlign: "center" }}>
                        {group.suggested_ship_vendor || "-"}
                      </TableCell>
                      <TableCell style={{ textAlign: "center" }}>
                        {group.vehicle?.dispatch_date
                          ? "Dispatched"
                          : "Not Dispatched" || "-"}
                      </TableCell>
                      <TableCell style={{ textAlign: "center" }}>
                        {Math.ceil(group?.vehicle?.booking?.invoice?.paid) ===
                          Math.ceil(group?.vehicle?.booking?.invoice?.amount) &&
                        group?.vehicle?.booking?.invoice?.paid &&
                        group?.vehicle?.booking?.invoice?.amount !== "0.000"
                          ? "Paid"
                          : Math.ceil(
                              group?.vehicle?.booking?.invoice?.paid
                            ) === 0 ||
                            Math.ceil(
                              group?.vehicle?.booking?.invoice?.amount
                            ) === 0
                          ? "UnPaid"
                          : "Partial Paid"}{" "}
                      </TableCell>
                      <TableCell style={{ textAlign: "center" }}>
                        $
                        {CommaSeparator(
                          parseFloat(group.towing_cost).toFixed(2)
                        )}
                      </TableCell>
                      <TableCell style={{ textAlign: "center" }}>
                        $
                        {CommaSeparator(
                          parseFloat(group.shipping_cost).toFixed(2)
                        )}
                      </TableCell>
                      <TableCell style={{ textAlign: "center" }}>
                        $
                        {CommaSeparator(
                          parseFloat(group.estimated_price * 1).toFixed(2)
                        )}
                      </TableCell>
                      <TableCell style={{ textAlign: "center" }}>
                        {group?.vehicle?.plans?.note || "-"}
                      </TableCell>
                      <TableCell style={{ textAlign: "center" }}>
                        <Box
                          component={"div"}
                          className="pdf-hide"
                          sx={{ gap: "16px !important" }}
                        >
                          <DropdownMenu
                            pdf={false}
                            item={group}
                            permissions={permissions}
                            navigate={navigate}
                            ErrorToaster={ErrorToaster}
                            Colors={Colors}
                            isOpen={activeMenu === group?.vehicle?.id}
                            onToggle={(isOpen) =>
                              handleMenuToggle(group?.vehicle?.id, isOpen)
                            }
                            id={group?.vehicle?.id}
                            onEdit={() => {
                              // Combine vehicles with the same group.id
                              const matchingVehicles = vendorPlans.filter(
                                (plan) => plan.id === group.id
                              );
                              // Construct the new group object with the full vehicles array
                              const groupWithVehicles = {
                                ...group,
                                vehicles: matchingVehicles,
                              };

                              // Navigate with the enriched group
                              navigate("/update-plan", {
                                state: { plan: groupWithVehicles },
                              });
                            }}
                            vendorPlan={true}
                            // isAdmin={user?.user_type == 'A'}
                            onDeleteClick={() => {
                              setOpenDeleteDialog(true);
                              // handleMenuToggle(false)
                              // setOpenDeleteModal(true);
                              setPlanId(group);
                            }}
                            onClick2={() => {
                              const matchingVehicles = vendorPlans
                                .filter((plan) => plan.id === group.id)
                                .map((plan) => plan.vehicle);

                              // Construct the new group object with the full vehicles array
                              const groupWithVehicles = {
                                ...group,
                                vehicles: matchingVehicles,
                              };
                              navigate(`/plan-detail/${group?.id}`, {
                                state: { vehicles: groupWithVehicles },
                              });
                            }}
                            excelDownload={() =>
                              downloadExcel(group?.booking_ref_no)
                            }
                          />
                        </Box>
                      </TableCell>
                    </TableRow>

                    {/* Collapsible Row - Detailed Vehicles in the Plan */}
                    <TableRow>
                      <TableCell
                        colSpan={9}
                        style={{ paddingBottom: 0, paddingTop: 0 }}
                      >
                        <Collapse in={open[index]} timeout="auto" unmountOnExit>
                          <Box margin={1}>
                            {/* <Box display="flex" gap={3}>
                              <Typography variant="h6" gutterBottom>
                                Vehicles ({group?.vehicles?.length})
                              </Typography>
                              <Typography variant="h6" gutterBottom>
                                Dispatched Vehicles (
                                {
                                  group?.vehicles?.filter(
                                    (row) => row.dispatch_status
                                  ).length
                                }
                                )
                              </Typography>
                            </Box> */}
                            {/* <FormControl component="fieldset">
                              <RadioGroup
                                row
                                value={dispatchFilter}
                                onChange={handleFilterChange}
                              >
                                <FormControlLabel
                                  value="all"
                                  control={<Radio />}
                                  label="All"
                                />
                                <FormControlLabel
                                  value="dispatched"
                                  control={<Radio />}
                                  label="Dispatched"
                                />
                                <FormControlLabel
                                  value="notDispatched"
                                  control={<Radio />}
                                  label="Not Dispatched"
                                />
                              </RadioGroup>
                            </FormControl> */}
                            <Table size="small">
                              <TableHead>
                                <TableRow>
                                  <TableCell>Customer</TableCell>
                                  <TableCell>Auctioneer</TableCell>
                                  <TableCell>Purchase Date</TableCell>
                                  <TableCell>Master ID</TableCell>
                                  <TableCell>Buyer ID</TableCell>
                                  <TableCell>VIN</TableCell>
                                  <TableCell>LOT</TableCell>
                                  <TableCell>Model</TableCell>
                                  <TableCell>Title</TableCell>
                                  <TableCell>Location</TableCell>
                                  <TableCell>Load Port</TableCell>
                                  <TableCell>GP Pin</TableCell>
                                  <TableCell>Off Site</TableCell>
                                  <TableCell>Destination</TableCell>
                                  <TableCell>Shipping Vendor</TableCell>
                                  <TableCell>Status</TableCell>
                                  <TableCell>Veh.Status</TableCell>
                                  <TableCell>Notes</TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                <TableCell>
                                  {group.customer_name || "-"}
                                </TableCell>
                                <TableCell>
                                  {group.booking?.auctioneer || "-"}
                                </TableCell>
                                <TableCell>
                                  {group.booking?.purchase_date?.slice(0, 10) ||
                                    "-"}
                                </TableCell>
                                <TableCell>
                                  {group.booking?.buyer?.master_id || "-"}
                                </TableCell>
                                <TableCell>
                                  {group.booking?.buyer?.name || "-"}
                                </TableCell>
                                <TableCell>
                                  {group.vehicle?.vin || "-"}
                                </TableCell>
                                <TableCell>
                                  {group.vehicle?.lot_number || "-"}
                                </TableCell>
                                <TableCell>
                                  {group.vehicle?.veh_model?.name || "-"}
                                </TableCell>
                                <TableCell>
                                  {group.vehicle?.title_status || "-"}
                                </TableCell>
                                <TableCell>
                                  {group.vehicle?.source || "-"}
                                </TableCell>
                                <TableCell>
                                  {group.vehicle?.loading_port?.name || "-"}
                                </TableCell>
                                <TableCell>
                                  {group.booking?.gp_pin || "-"}
                                </TableCell>
                                <TableCell>
                                  {group.booking?.off_site || "-"}
                                </TableCell>
                                <TableCell>
                                  {group.vehicle?.dest?.name || "-"}
                                </TableCell>
                                <TableCell>
                                  {group.suggested_ship_vendor || "-"}
                                </TableCell>
                                <TableCell>
                                  {group.vehicle?.dispatch_status
                                    ? "Dispatched"
                                    : "Not Dispatched"}
                                </TableCell>
                                <TableCell>
                                  {Math.ceil(
                                    group?.vehicle?.booking?.invoice?.paid
                                  ) ===
                                    Math.ceil(
                                      group?.vehicle?.booking?.invoice?.amount
                                    ) &&
                                  group?.vehicle?.booking?.invoice?.paid &&
                                  group?.vehicle?.booking?.invoice?.amount !==
                                    "0.000"
                                    ? "Paid"
                                    : Math.ceil(
                                        group?.vehicle?.booking?.invoice?.paid
                                      ) === 0 ||
                                      Math.ceil(
                                        group?.vehicle?.booking?.invoice?.amount
                                      ) === 0
                                    ? "UnPaid"
                                    : "Partial Paid"}{" "}
                                </TableCell>
                                <TableCell>
                                  {group.vehicle?.dispatch_notes || "-"}
                                </TableCell>
                              </TableBody>
                            </Table>
                          </Box>
                        </Collapse>
                      </TableCell>
                    </TableRow>
                  </React.Fragment>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </PDFExport>
      {/* ========== Pagination ========== */}
      <Pagination
        currentPage={currentPage}
        pageSize={pageLimit}
        onPageSizeChange={(e) => {
          const newLimit = parseInt(e.target.value);
          setCurrentPage(1);
          setPageLimit(newLimit);
          getVendorPlan(1, newLimit);
        }}
        tableCount={planVendor?.length || 0}
        totalCount={totalCount}
        onPageChange={(page) => {
          setCurrentPage(page);
          getVendorPlan(page, pageLimit);
        }}
      />
    </Box>
  );
};

export default LoadingPlanList;
